import round from 'lodash/round';
import Field from '../Field';

const _ = {
  round,
};

const defaultValue = '';

class Integer extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    const { precision } = this.config;

    this.value.forEach((val, index) => {
      if (Field.isEmpty(val)) {
        this.setValue(defaultValue, index);
        this.setDisplayValue(defaultValue, index);
        return;
      }

      if (force || this.validIndex[index]) {
        let saneValue = val;

        // We don't want to round anything if a precision isn't given
        if (precision) {
          saneValue = parseFloat(_.round(val, precision)).toFixed(precision);
        } else {
          saneValue = parseInt(val, 10);
        }

        // Fall back to defaultValue of the value is not a number
        if (Number.isNaN(saneValue)) {
          saneValue = defaultValue;
        }

        this.setValue(saneValue, index);
        this.setDisplayValue(saneValue, index);
      }
    });

    return this;
  }

  validate() {
    super.validate();
    const regex = /^-?\d+(?:\.?\d*)$/;

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      if (!regex.test(val)) {
        this.invalidate('Invalid number value.', index);
      }
    });

    return this.isValid();
  }
}

export default Integer;
